<template>
  <div class="page_projectSet">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.pojectId" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item :to="{path:'/calcSalary'}">算薪</el-breadcrumb-item>
          <el-breadcrumb-item>指定项目配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="addHandel">添加项目</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" :max-height="tableHeight-100 > 340 ? tableHeight-100 : 340" v-loading="loading" style="width:500px">
          <el-table-column prop="pojectName" label="项目名称" min-width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="delHandel(row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 新增/编辑 -->
    <el-dialog title="添加项目" :visible.sync="addVisible" width="600px" class="res_dialog enter_dialog">
      <el-form ref="addForm" :model="addForm" class="" label-width="100px" size="small" v-if="addVisible">
        <el-form-item label="项目:">
          <el-select v-model="project" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable @change="changePro">
            <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAdd" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: []
          },
          id: '',
          pojectId: '',
          pojectName: '',
          msg: ''
        },
        proNameList: [],
        addForm: {
          id: '',
          pojectId: '',
          pojectName: '',
          msg: ''
        },
        project: '',
        isbtnLoading: false,
        addVisible: false,
        tableData: [],
        roletype: localStorage.loginRoletype,
        loading: false,
      }
    },
    created() {
      this.getProList();
      this.getList();
    },
    methods: {
      checkPermission,
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      getList() {
        this.GetFieldMatchingList();
      },
      GetFieldMatchingList() {
        this.loading = true;
        xz.ArdCurStat(this.listQuery, 'GetProjectLoadingDistributioPath').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      addHandel() {
        this.addForm = {
          id: '',
          pojectId: '',
          pojectName: '',
          msg: ''
        }
        this.isbtnLoading = false;
        this.addVisible = true;
      },
      //选择项目
      changePro(val) {
        this.addForm.pojectId = val.Projectid;
        this.addForm.pojectName = val.StrprojectName;
      },
      confirmAdd() {
        if (this.addForm.pojectId) {
          this.isbtnLoading = true;
          xz.ArdCurStat(this.addForm, 'AddProjectLoadingDistributioPath').then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.isbtnLoading = false;
              this.addVisible = false;
              this.$message.success("添加成功")
            } else {
              this.isbtnLoading = false;
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.warning("请选择项目")
        }
      },
      delHandel(row) {
        let d = {
          id: row.id,
          isDelete: '1'
        }
        xz.ArdCurStat(d, 'AddProjectLoadingDistributioPath').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.$message.success("删除成功")
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }
</style>
<style>
  .page_projectSet .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_projectSet .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_projectSet .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_projectSet .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_projectSet .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_projectSet .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>